<div siqGrid fx-direction="column" fx-layout-align="start start">
  <span aria-hidden="true" class="mb-12 siq-text-400 fs-16 white"> {{label}} </span>
  <div role="region" class="input-container w-100-p">
    @if(isMaskedInput) {
      <input 
        id="siq-input"
        appInputFormat
        maxlength="12"
        [class]="inputClasses"
        [attr.aria-label]="ariaLabel"
        [tabIndex]="tabIndex"
        type="text" 
        (focus)="onFocus()"
        (blur)="onBlur()"
        [placeholder]="placeholder" 
        [(ngModel)]="control"/>
    } @else {
      <input 
        id="siq-input"
        [class]="inputClasses"
        [tabIndex]="tabIndex"
        [attr.aria-label]="ariaLabel"
        [type]="type" 
        (focus)="onFocus()"
        (blur)="onBlur()"
        [placeholder]="placeholder" 
        [attr.maxlength]="maxLength"
        [(ngModel)]="control"/>
    }
    @if(isPasswordField) {
      <div aria-hidden="true" tabindex="-1"  *ngIf="type === 'text' && isPasswordField" (click)="setPasswordType('password')"
        class="input-icon show-password-icon cursor-pointer"></div>
      <div aria-hidden="true" tabindex="-1"  *ngIf="type === 'password'" (click)="setPasswordType('text')"
        class="input-icon hide-password-icon cursor-pointer"></div>
    } @else {
      <div aria-hidden="true" tabindex="-1" *ngIf="showResetInput" class="input-icon cursor-pointer" (mousedown)="resetField($event)">
        <span class="close-white-icon"></span>
      </div>
    }
  </div>
</div>